(async () => {
  const configNode = document.getElementById('CzWishlistConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const text = config.text, key = 'cz.wishlist.v1', limit = 100;
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const validHandle = value => typeof value === 'string' && /^[a-z0-9-]+$/.test(value);
  const normalize = value => Array.isArray(value) ? [...new Set(value.filter(validHandle))].slice(0, limit) : [];
  let plus = {};
  try { plus = JSON.parse(document.getElementById('CzWishlistPlusConfig')?.textContent || '{}'); } catch {}
  const cloud = plus.enabled === true && plus.customer === true;
  const pt = plus.text || {};
  let remote = null, busy = false;
  const api = async (path, body) => {
    const response = await fetch(plus.proxy + path, {credentials:'same-origin', cache:'no-store', method: body ? 'POST' : 'GET', headers:{Accept:'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify({...body,csrf:remote?.csrf})} : {})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || pt.error);
    remote = result;
    return result;
  };
  let handles = [], storageAvailable = true, renderVersion = 0, toastTimer;
  try { const stored = localStorage.getItem(key); try { handles = normalize(JSON.parse(stored || '[]')); } catch { handles = []; } } catch { storageAvailable = false; }
  const money = value => {
    try { return new Intl.NumberFormat(config.locale || 'fr', {style: 'currency', currency: config.currency || 'EUR'}).format(Number(value) / 100); }
    catch { return `${(Number(value) / 100).toFixed(2)} ${config.currency || 'EUR'}`; }
  };
  const announce = message => {
    const node = document.querySelector('[data-wishlist-toast]');
    if (!node) return;
    node.textContent = message; node.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { node.hidden = true; }, 3500);
  };
  const updateControls = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const active = handles.includes(button.dataset.wishlistHandle), title = button.dataset.wishlistTitle || '';
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? text.remove : text.add} ${title}`);
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? text.remove_item : text.add.replace(/\s*:\s*$/, '');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(node => {
      node.textContent = String(handles.length);
      if (node.closest('.cz-wishlist-link')) node.hidden = !handles.length;
    });
  };
  const save = async next => {
    if (busy) return false;
    if (cloud) {
      if (!remote) { announce(pt.offline); return false; }
      busy = true;
      try {
        const added = next.find(h => !handles.includes(h)), removed = handles.find(h => !next.includes(h));
        await api('/item', {handle:added || removed, remove:!!removed});
        handles = normalize(remote.handles); updateControls(); renderList(); return true;
      } catch (error) { announce(error.message || pt.error); return false; } finally { busy = false; }
    }
    if (!storageAvailable) { announce(text.storage_error); return false; }
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { announce(text.storage_error); return false; }
    handles = next; updateControls(); renderList(); return true;
  };
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  const removeButton = handle => {
    const node = element('button', 'btn btn-ghost cz-wishlist-remove', text.remove_item);
    node.type = 'button'; node.dataset.wishlistRemove = handle; return node;
  };
  const imageUrl = value => {
    if (typeof value !== 'string') return null;
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' || url.origin === location.origin ? url.href : null; } catch { return null; }
  };
  const productCard = (product, handle) => {
    const card = element('article', 'product-card cz-product-card cz-wishlist-product');
    const url = `${root}products/${encodeURIComponent(handle)}`;
    const visual = element('a', 'cz-product-image'); visual.href = url; visual.setAttribute('aria-label', product.title);
    const src = imageUrl(product.featured_image);
    if (src) { const image = element('img'); image.src = src; image.alt = product.title; image.loading = 'lazy'; visual.append(image); }
    else visual.append(element('span', '', product.title));
    card.append(visual);
    const info = element('div', 'product-info');
    if (!product.available) info.append(element('span', 'badge cz-sold-out-badge', text.sold_out));
    const title = element('a', 'name', product.title); title.href = url; info.append(title);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    let selected = variants.find(variant => variant.available) || variants[0] || {price:product.price,compare_at_price:product.compare_at_price,available:product.available};
    const price = element('div', 'price'); info.append(price); card.append(info);
    const actions = element('div', 'cz-card-action');
    const select = variants.length > 1 ? element('select', 'cz-wishlist-variant') : null;
    if (select) {
      const label = element('label', 'cz-wishlist-variant-label', text.variant);
      variants.forEach(variant => { const option = element('option', '', `${variant.title} — ${money(variant.price)}${variant.available ? '' : ` — ${text.sold_out}`}`); option.value = String(variant.id); select.append(option); });
      select.value = String(selected.id); label.append(select); actions.append(label);
    }
    const requiresConfiguration = product.requires_selling_plan || (product.selling_plan_groups || []).length > 0;
    const preorder = (product.tags || []).some(tag => /^(précommandes?|precommandes?|pre-?orders?)$/i.test(tag));
    const add = element(requiresConfiguration ? 'a' : 'button', 'btn btn-primary cz-wishlist-add');
    if (requiresConfiguration) add.href = url;
    else add.type = 'button';
    const status = element('p', 'cz-wishlist-cart-status'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.hidden = true;
    const updateVariant = () => {
      price.replaceChildren();
      if (Number(selected.compare_at_price) > Number(selected.price)) {
        price.classList.add('cz-sale-price');
        const old = element('s', 'old', money(selected.compare_at_price)); old.setAttribute('aria-label',text.old_price); price.append(old,document.createTextNode(' '));
      } else price.classList.remove('cz-sale-price');
      const current = element('span', '', money(selected.price)); if (price.classList.contains('cz-sale-price')) current.setAttribute('aria-label',text.sale_price); price.append(current);
      const unavailable = !selected.available;
      let badge = info.querySelector('.cz-sold-out-badge');
      if (unavailable && !badge) { badge = element('span','badge cz-sold-out-badge',text.sold_out); info.prepend(badge); }
      if (!unavailable && badge) badge.remove();
      if (requiresConfiguration) { add.textContent = text.choose_options; add.href = `${url}?variant=${encodeURIComponent(selected.id)}`; }
      else { add.disabled = unavailable || !selected.id; add.textContent = unavailable ? text.sold_out : preorder ? text.preorder : text.add_cart; }
    };
    if (select) select.addEventListener('change', () => { selected = variants.find(variant => String(variant.id) === select.value); status.hidden = true; updateVariant(); });
    if (!requiresConfiguration) add.addEventListener('click', async () => {
      if (add.disabled || !selected.available) return;
      add.disabled = true; if (select) select.disabled = true; add.textContent = text.adding; status.hidden = true;
      try {
        const response = await fetch(`${root}cart/add.js`, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:selected.id,quantity:1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || text.cart_error);
        status.textContent = text.added_cart; status.classList.remove('is-error'); status.hidden = false;
        const cartLink = element('a','',text.view_cart || 'Voir le panier'); cartLink.href = `${root}cart`; status.append(document.createTextNode(' '),cartLink);
        try { const cartResponse = await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}}); if(cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cart.item_count); } } catch (_) {}
      } catch (error) { status.textContent = error.message || text.cart_error; status.classList.add('is-error'); status.hidden = false; }
      finally { if(select) select.disabled = false; updateVariant(); }
    });
    if (cloud && remote) {
      for (const kind of ['price', 'restock']) {
      if (kind === 'price' && config.currency !== 'EUR') continue;
      const alertLabel = element('label','cz-plus-alert');
      const alertInput = element('input'); alertInput.type = 'checkbox';
      alertInput.dataset.alertKind = kind;
      const alertText = element('span','',kind === 'restock' ? pt.restock_alert : pt.alert); alertLabel.append(alertInput,alertText); actions.append(alertLabel);
      const refreshAlert = () => {
        alertInput.checked = (remote[kind === 'restock' ? 'restocks' : 'alerts'] || []).some(a => a.handle === handle && a.variant === String(selected.id) && a.active);
        alertInput.disabled = !remote.verified || !selected.id;
        alertLabel.title = remote.verified ? '' : pt.verify_first;
      };
      if (select) select.addEventListener('change',refreshAlert);
      alertInput.addEventListener('change',async()=>{
        const enabled = alertInput.checked; alertInput.disabled = true;
        try { await api(kind === 'restock' ? '/restock' : '/alert',{handle,variant:String(selected.id),enabled,consent:enabled,currency:config.currency}); announce(pt.saved); }
        catch(error) { announce(error.message || pt.error); }
        finally { refreshAlert(); }
      });
      refreshAlert();
      }
    }
    updateVariant();
    const link = element('a', 'cz-wishlist-view', `${text.view} →`); link.href = url;
    actions.append(add,status,link,removeButton(handle)); card.append(actions); return card;
  };
  const renderList = async () => {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    const version = ++renderVersion, list = [...handles];
    const grid = page.querySelector('[data-wishlist-grid]'), empty = page.querySelector('[data-wishlist-empty]'), loading = page.querySelector('[data-wishlist-loading]'), summary = page.querySelector('[data-wishlist-summary]');
    grid.replaceChildren(); empty.hidden = !!list.length; summary.hidden = !list.length; loading.hidden = !list.length;
    if (!list.length) return;
    const slots = list.map(handle => {
      const node = element('article', 'cz-wishlist-placeholder'); node.setAttribute('aria-busy', 'true'); grid.append(node); return {handle, node};
    });
    let cursor = 0;
    const worker = async () => {
      while (cursor < slots.length && version === renderVersion) {
        const {handle, node} = slots[cursor++];
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {credentials: 'same-origin'});
          if (!response.ok) { const error = new Error('product'); error.notFound = response.status === 404; throw error; }
          const product = await response.json();
          if (!product || typeof product.title !== 'string' || !Number.isFinite(Number(product.price))) throw new Error('product');
          if (version !== renderVersion) return;
          node.replaceWith(productCard(product, handle));
        } catch (error) {
          if (version !== renderVersion) return;
          node.removeAttribute('aria-busy'); node.append(element('p', '', error.notFound ? text.unavailable : text.error), removeButton(handle));
          if (!error.notFound) { const retry = element('button', 'btn btn-ghost', text.retry); retry.type = 'button'; retry.dataset.wishlistRetry = ''; node.append(retry); }
        }
      }
    };
    await Promise.all(Array.from({length: Math.min(4, slots.length)}, worker));
    if (version === renderVersion) loading.hidden = true;
  };
  document.addEventListener('click', async event => {
    const target = event.target;
    const toggle = target.closest('[data-wishlist-toggle]');
    if (toggle) {
      const handle = toggle.dataset.wishlistHandle;
      if (!validHandle(handle)) return;
      const active = handles.includes(handle);
      if (!active && handles.length >= limit) { announce(text.limit); return; }
      if (await save(active ? handles.filter(value => value !== handle) : [...handles, handle])) announce(active ? text.removed : text.added);
    }
    const remove = target.closest('[data-wishlist-remove]');
    if (remove && await save(handles.filter(handle => handle !== remove.dataset.wishlistRemove))) announce(text.removed);
    if (target.closest('[data-wishlist-retry]')) renderList();
  });
  window.addEventListener('storage', event => {
    if (cloud) return;
    if (event.key !== key && event.key !== null) return;
    try { handles = normalize(JSON.parse(event.newValue || '[]')); } catch { handles = []; }
    updateControls(); renderList();
  });
  document.addEventListener('shopify:section:load', updateControls);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-wishlist-toggle]') || node.querySelector('[data-wishlist-toggle]'))))) updateControls();
  }).observe(document.body, {childList: true, subtree: true});
  const plusBox = document.querySelector('[data-plus-box]');
  const plusStatus = document.querySelector('[data-plus-status]');
  if (cloud) {
    busy = true;
    try {
      await api('/state');
      if (handles.length) {
        await api('/merge',{handles});
        try { localStorage.removeItem(key); } catch {}
      }
      handles = normalize(remote.handles);
      if (plusStatus) plusStatus.textContent = pt.sync;
    } catch {
      if (plusStatus) plusStatus.textContent = pt.offline;
      remote = null;
    } finally { busy = false; }
  }
  if (plusBox && plus.enabled) {
    plusBox.hidden = false;
    const login = plusBox.querySelector('[data-plus-login]');
    if (login) login.hidden = cloud;
    const form = plusBox.querySelector('[data-plus-email]');
    if (form) {
      form.hidden = !cloud || !remote || remote.verified;
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        const button = form.querySelector('button'); button.disabled = true;
        try {
          remote = await api('/email',{consent:form.querySelector('input[type="checkbox"]').checked,locale:config.locale});
          form.hidden = remote.verified;
          plusStatus.textContent = pt.verified;
          renderList();
        } catch(error) { plusStatus.textContent = error.message || pt.error; }
        finally { button.disabled = false; }
      });
    }
    if (remote?.verified && plusStatus) plusStatus.textContent = pt.verified;
    const erase = plusBox.querySelector('[data-plus-erase]');
    if (erase) {
      erase.hidden = !cloud || !remote;
      erase.addEventListener('click',async()=>{
        if (!confirm(pt.erase_confirm)) return;
        erase.disabled = true;
        try { await api('/erase',{}); handles=[]; updateControls(); renderList(); plusStatus.textContent=pt.erased; remote=null; }
        catch(error) { plusStatus.textContent=error.message || pt.error; }
        finally { erase.disabled=false; }
      });
    }
    const reload = plusBox.querySelector('[data-plus-reload]');
    if (reload) { reload.hidden = !cloud; reload.addEventListener('click',()=>location.reload()); }
  }
  updateControls(); renderList();
})();
